import { Component } from '@angular/core';
import { ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';

import { CrudFormFooterComponent } from '@admin/components/crud-form-footer/crud-form-footer.component';
import { CrudFormHeaderComponent } from '@admin/components/crud-form-header/crud-form-header.component';
import { CrudFormComponent } from '@admin/components/crud-form/crud-form.component';
import { AlertComponent } from '@shared/components/alert/alert.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-permissions-form',
    imports: [
        NgClass,
        ReactiveFormsModule,
        MatInputModule,
        FormsModule,
        AlertComponent,
        CrudFormHeaderComponent,
        CrudFormFooterComponent,
    ],
    templateUrl: './permissions-form.component.html',
    styleUrl: './permissions-form.component.scss'
})
export class PermissionsFormComponent extends CrudFormComponent {
  resources: string[] = [];
  types: string[] = [];

  override data = this.formBuilder.group({
    name: ['', [Validators.required]],
    code: ['', [Validators.required]],
  });

  override handleLoadResponse(responses: any[]): void {
    if (this.dataId() !== -1 && responses[0] && responses[0].status === 200) {
      const responseData = responses[0].data;
      this.data.patchValue(responseData);
    }
  }

  override getParams() {
    const params = this.data.value;

    return params;
  }

  override getFormatEndpoint(): string {
    return this.endpoint.startsWith('admin/')
      ? this.endpoint
      : 'admin/' + this.endpoint;
  }

  override initSettings(): void {
    if (this.readonly) this.data.disable();
  }
}
